// To do:
// - 
// 

import React, { useState, useEffect, useCallback } from 'react';
import { Paragraph, Tab, Tabs, Box, Text } from 'grommet';
import { PageHeader, Page, PageContent } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { LatestAbstractsComp } from './repos/LatestAbstracts';
import { useLocation, useNavigate } from 'react-router-dom';
import './page.css';

export const LatestHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const tabTitles = ['agenda', 'posters', 'presentations', 'abstracts', 'replays'];

  // 👇 Memoize this function so useEffect knows when it's actually changed
  const getTabIdFromUrl = useCallback(() => {
    const match = location.pathname.match(/\/latest\/([a-z-]+)/);
    return match ? match[1] : 'agenda';
  }, [location.pathname]);

  const [activeLatestTab, setActiveLatestTab] = useState(getTabIdFromUrl);

  // Sync state with URL when the location changes
  useEffect(() => {
    const tabIdFromUrl = getTabIdFromUrl();
    setActiveLatestTab(tabIdFromUrl);
  }, [getTabIdFromUrl]);

  // Update the browser URL when the tab changes
  useEffect(() => {
    navigate(`/latest/${activeLatestTab.toLowerCase()}`);
  }, [activeLatestTab, navigate]);

  const activeTabIndex = tabTitles.indexOf(activeLatestTab);

  return (
    <Page flex="grow" background="background-back">
      <Box
        background="url('/images/hpe-tech-surface.jpg')"
        height={{ min: '140px', max: 'auto' }}
        margin={{ top: 'none' }}
        pad={{ bottom: 'small' }}
        style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Box margin={{ top: 'none', left: 'large' }} pad={{ horizontal: 'small' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={
              <Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>
                Tech Con 2025
              </Text>
            }
            subtitle={'Another great year of community and innovation'}
            style={{ color: 'white' }}
            size="medium"
          />
        </Box>
      </Box>

      <PageContent flex="grow" background="background-back" width="80%">
        <Tabs
          activeIndex={activeTabIndex}
          onActive={(index) => setActiveLatestTab(tabTitles[index])}
          justify="start"
          pad={{ top: 'medium' }}
        >
          <Tab title="Agenda">
            <MapTabContent>
              <Paragraph margin="none">Agenda coming soon!</Paragraph>
            </MapTabContent>          
          </Tab>
          <Tab title="Posters">
            <MapTabContent>
              <Paragraph margin="none">Posters coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Presentations">
            <MapTabContent>
              <Paragraph margin="none">Presentations coming soon!</Paragraph>
            </MapTabContent>
          </Tab>
          <Tab title="Selected Abstracts">
            <LatestAbstractsComp />
          </Tab>
          <Tab title="Video Replays">
            <MapTabContent>
              <Paragraph margin="none">Video replays coming soon!</Paragraph>
            </MapTabContent>
          </Tab>          
        </Tabs>
      </PageContent>
    </Page>
  );
};
